<template>
  <j-modal
    :width="600"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    @cancel="handleCancel"
    :footer="null"
  >
    <div slot="title" style="font-size: 16px; font-weight: 600">处理详情</div>
    <div>
      <template v-if="detailList.length">
        <div v-for="(item, index) in detailList" :key="index" class="list-item">
          <div class="left-area">
            <span style="font-weight: bold">{{ item.name }}</span>
            <span style="margin-top: 6px">{{ item.comment }}</span>
          </div>
          <div>{{ item.createTime }}</div>
        </div>
      </template>
      <div v-else style="padding: 40px 0; text-align: center; font-size: 18px; color: #ccc">
        暂无数据
      </div>
    </div>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import { postAction } from '@api/manage'

export default {
  name: 'HandleDetailModal',
  components: {
    JDate,
  },
  props: {
    detailList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      // detailList: [
      //   { name: '张三', label: '已预约心理老师', time: '2021-08-01 10:00' },
      //   { name: '张三', label: '已完成预约心理', time: '2021-08-01 10:00' },
      //   { name: '张三', label: '已上报', time: '2021-08-01 10:00' },
      // ],
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data) {
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  .left-area {
    display: flex;
    flex-direction: column;
  }
}
</style>
